module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0111.jpg?v=9e8dbfa2";